// extracted by mini-css-extract-plugin
export default {"timeCall":"Room_timeCall__6ZBcl","timeCallIcon":"Room_timeCallIcon__N0zC-","timeCallTime":"Room_timeCallTime__AzTpa"};